// extracted by mini-css-extract-plugin
export default {"contactUsPage__callUsSection__text":"contactUsPage__callUsSection__text_kwBX_d9Q"};